import React from 'react';

import Icon from 'dpl/common/components/Icon';
import { PRIVACY_PATH, TOS_PATH } from 'dpl/shared/constants/urls';

import { PAYMENT_TIER_TYPE, US_BANK_ACCOUNT_PAYMENT_METHOD } from './constants';

type PaymentTierType =
  (typeof PAYMENT_TIER_TYPE)[keyof typeof PAYMENT_TIER_TYPE];

interface StripeChargeModalFooterProps {
  paymentMethod?: string | null;
  paymentTier?: PaymentTierType;
  hideProtectedLine?: boolean;
}

export default function StripeChargeModalFooter({
  paymentMethod = null,
  paymentTier,
  hideProtectedLine = false
}: StripeChargeModalFooterProps) {
  return (
    <div className="StripeChargeModalFooter pt6">
      {paymentTier === PAYMENT_TIER_TYPE.PROTECTED && !hideProtectedLine && (
        <div className="flex items-center justify-center gap-6 mb4">
          <Icon
            className="blue-500"
            height="24px"
            name="gooddog-shield"
            width="24px"
          />
          <p className="font-14">
            Your payment is secure and protected by Good Dog.
          </p>
        </div>
      )}
      <p className="font-12 tc tertiary">
        By paying you agree to Good Dog&apos;s{' '}
        <a
          href={TOS_PATH}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Terms of Service
        </a>{' '}
        and{' '}
        <a
          href={PRIVACY_PATH}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Privacy Policy
        </a>
        .
        {paymentMethod &&
          paymentMethod === US_BANK_ACCOUNT_PAYMENT_METHOD &&
          ` Good Dog verifies your bank account details and checks your balances
            to make sure you have sufficient funds before initiating an ACH
            transaction.
          `}
      </p>
    </div>
  );
}
